import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import { AlgorithmIdentifier, Certificate } from "@peculiar/asn1-x509";
import { ResponseData } from "./response_data";
export class BasicOCSPResponse {
    constructor(params = {}) {
        this.tbsResponseData = new ResponseData();
        this.signatureAlgorithm = new AlgorithmIdentifier();
        this.signature = new ArrayBuffer(0);
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: ResponseData, raw: true })
], BasicOCSPResponse.prototype, "tbsResponseData", void 0);
__decorate([
    AsnProp({ type: AlgorithmIdentifier })
], BasicOCSPResponse.prototype, "signatureAlgorithm", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.BitString })
], BasicOCSPResponse.prototype, "signature", void 0);
__decorate([
    AsnProp({ type: Certificate, repeated: "sequence", optional: true, context: 0 })
], BasicOCSPResponse.prototype, "certs", void 0);
